// utils/helpers.js

/**
 * Checkt of een object leeg is
 * @param {Object} obj
 * @returns {boolean}
 */
export function isEmptyObject(obj) {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

export function getChipLabel(items, getLabelFn, maxVisible = 2) {
  const total = items.length;
  if (total === 0) return "";

  const labels = items.map(getLabelFn);

  if (total <= maxVisible) {
    return labels.join(", ");
  }

  const visible = labels.slice(0, maxVisible).join(", ");
  return `${visible} en ${total - maxVisible} meer`;
}

export function getUuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export function isFilled(val) {
  if (val === null || val === undefined) return false;
  if (typeof val === "string") return val.trim().length > 0;
  return true;
}

export function isFilledBoolOrText(b, t) {
  return b === true || (typeof t === "string" && t.trim().length > 0);
}